import {TARGET_URL} from 'services/config';

const Header = () => {
  return (
    <div className=" bg-white flex justify-between p-4 shadow-lg -mx-3  sticky top-0 z-10">
      <p className=" text-gray-6">حجره</p>

      <a href={TARGET_URL}>
        <span className="icon-mazrae-man text-gray-6 text-2xl" />
      </a>
    </div>
  );
};

export default Header;
